import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BulkOperationsPanel } from '@/components/access-control/BulkOperationsPanel';
import { Zap, Users, Building } from 'lucide-react';

// Mock data - in real app, this would come from API
const mockWorkspaces = [
  { id: '1', name: 'Acme Corp', plan: 'Enterprise', members: 15 },
  { id: '2', name: 'Tech Solutions', plan: 'Pro', members: 8 },
  { id: '3', name: 'Local Business', plan: 'Basic', members: 3 },
  { id: '4', name: 'Global Industries', plan: 'Enterprise', members: 25 },
  { id: '5', name: 'Startup Inc', plan: 'Pro', members: 5 },
];

export default function BulkOperations() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center gap-3">
        <Zap className="h-8 w-8 text-primary" />
        <div>
          <h1 className="text-3xl font-bold">Bulk Operations</h1>
          <p className="text-muted-foreground">
            Manage multiple workspaces efficiently with bulk operations
          </p>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Workspaces</CardTitle>
            <Building className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{mockWorkspaces.length}</div>
            <p className="text-xs text-muted-foreground">
              Across all plans
            </p>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Members</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {mockWorkspaces.reduce((sum, w) => sum + w.members, 0)}
            </div>
            <p className="text-xs text-muted-foreground">
              Across all workspaces
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Enterprise Plans</CardTitle>
            <Zap className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {mockWorkspaces.filter(w => w.plan === 'Enterprise').length}
            </div>
            <p className="text-xs text-muted-foreground">
              High-tier subscriptions
            </p>
          </CardContent>
        </Card>
      </div>

      {/* Bulk Operations Panel */}
      <BulkOperationsPanel workspaces={mockWorkspaces} />
    </div>
  );
}